import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "Apple",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      _cache[1] || (_cache[1] = _createStaticVNode("<linearGradient id=\"Nepojmenovaný_přechod_27\" x1=\"328.27\" x2=\"183.73\" y1=\"508.05\" y2=\"3.95\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#ffdb73\"></stop><stop offset=\".08\" stop-color=\"#fdad4e\"></stop><stop offset=\".15\" stop-color=\"#fb832e\"></stop><stop offset=\".19\" stop-color=\"#fa7321\"></stop><stop offset=\".23\" stop-color=\"#f6692f\"></stop><stop offset=\".37\" stop-color=\"#e84a5a\"></stop><stop offset=\".48\" stop-color=\"#e03675\"></stop><stop offset=\".55\" stop-color=\"#dd2f7f\"></stop><stop offset=\".68\" stop-color=\"#b43d97\"></stop><stop offset=\".97\" stop-color=\"#4d60d4\"></stop><stop offset=\"1\" stop-color=\"#4264db\"></stop></linearGradient>", 1)),
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".cls-2{fill:#fff}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("rect", {
      width: "465.06",
      height: "465.06",
      x: "23.47",
      y: "23.47",
      rx: "107.23",
      ry: "107.23",
      style: {"fill":"url(#Nepojmenovaný_přechod_27)"}
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M331 115.22a66.92 66.92 0 0 1 66.65 66.65v148.26A66.92 66.92 0 0 1 331 396.78H181a66.92 66.92 0 0 1-66.65-66.65V181.87A66.92 66.92 0 0 1 181 115.22zm0-31H181c-53.71 0-97.66 44-97.66 97.66v148.25c0 53.71 44 97.66 97.66 97.66h150c53.71 0 97.66-44 97.66-97.66V181.87c0-53.71-43.95-97.66-97.66-97.66Z",
      class: "cls-2"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M256 198.13A57.87 57.87 0 1 1 198.13 256 57.94 57.94 0 0 1 256 198.13m0-31A88.87 88.87 0 1 0 344.87 256 88.87 88.87 0 0 0 256 167.13",
      class: "cls-2"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("circle", {
      cx: "346.81",
      cy: "163.23",
      r: "21.07",
      class: "cls-2"
    }, null, -1))
  ]))
}
export default { render: render }